export function formatNumber(price) {
  if (price === null || price === undefined) return "0";
  
  // Remove non-numeric characters except for the decimal point
  const sanitizedPrice = typeof price === 'string' 
    ? price.replace(/[^\d.]/g, '') 
    : price;
    
  const numericPrice = Number(sanitizedPrice);

  if (isNaN(numericPrice)) return "0";

  return numericPrice.toLocaleString('en-US');
}
